import Vue from 'vue';
import toArray from './helpers/toArray';

import InputCount from './components/InputCount';
import SearchableScrollbox from './components/SearchableScrollbox';
import Sort from './components/Sort';
import Media from './components/Media';
import ManagedForm from './components/ManagedForm';
import StatefulTabs from './components/StatefulTabs';
import FormStore from './components/FormStore';
import Chart from './components/Chart';
import Datepicker from './components/Datepicker';
import ClickableTable from './components/ClickableTable';
import MediaBrowser from './components/MediaBrowser';
import Dashboard from './components/Dashboard';
import ListView from './components/ListView';
import CardStatistics from './components/CardStatistics';
import DownloadModal from './components/DownloadModal';
import ProductsModal from './components/ProductsModal';
import Duplicate from './components/Duplicate';
import Nestable from './components/Nestable';
import PartsSelector from './components/PartsSelector';
import ExportModal from './components/ExportModal';
import OrderLineForm from './components/OrderLineForm';
import SitemapIndex from './components/SitemapIndex';
import ToggleSwitch from './components/ToggleSwitch';
import NoteModal from './components/NoteModal';
import AddressAutofill from './components/AddressAutofill';
import OrderAutofill from './components/OrderAutofill';
import Menu from './components/Menu';
import PasswordStrength from './components/PasswordStrength';
import Inbox from './components/Inbox';
import Translations from './components/Translations';
import PageOverlay from './components/PageOverlay';
import Variants from './components/Variants';
import File from './components/File';
import SummarizeMetaDescription from './components/SummarizeMetaDescription';
import RichEditor from './components/Editor/RichEditor.vue';
import ModuleFieldConfigurator from './components/ModuleFieldConfigurator.vue';
import Form from './components/Form.vue';
import Blocks from './components/Blocks/Blocks.vue';
import MediaWidgetDecoupled from './components/MediaWidgetDecoupled.vue';
import Invoice from './components/Invoice';
import MetaEditor from './components/MetaEditor';
import TaxCalculation from './components/TaxCalculation';
import TagManagerConditions from './components/TagManagerConditions.vue';

export default {
  registeredComponents: {
    InputCount,
    SearchableScrollbox,
    Sort,
    Media,
    ManagedForm,
    StatefulTabs,
    FormStore,
    Chart,
    Datepicker,
    ClickableTable,
    MediaBrowser,
    Dashboard,
    ListView,
    CardStatistics,
    DownloadModal,
    ProductsModal,
    Duplicate,
    Nestable,
    PartsSelector,
    ExportModal,
    OrderLineForm,
    SitemapIndex,
    ToggleSwitch,
    NoteModal,
    AddressAutofill,
    OrderAutofill,
    Menu,
    PasswordStrength,
    Inbox,
    Translations,
    PageOverlay,
    Variants,
    File,
    RichEditor,
    ModuleFieldConfigurator,
    Form,
    Blocks,
    MediaWidgetDecoupled,
    Invoice,
    MetaEditor,
    TaxCalculation,
    TagManagerConditions,
    SummarizeMetaDescription,
  },

  /**
   * Create event listeners for any actions the component loader should take
   * @return {void}
   */
  createListeners() {
    window.pubsub.subscribe('components:evaluate', this.check.bind(this));
  },

  /**
   * Checks the current page for components
   * @return {void}
   */
  check() {
    const components = toArray(document.querySelectorAll('[data-component], [data-vanilla-component]'));

    // Loop through elements
    components.forEach((componentElement) => {
      if (componentElement.className.indexOf('is-initialized') >= 0) {
        return;
      }

      componentElement.className += ' is-initialized';

      // Render component inside element
      this.createComponentForElement(componentElement);
    });
  },

  /**
   * Create component inside element
   * @param {HTMLElement} node DOMNode to render the component in
   * @return {Void}
   */
  createComponentForElement(node) {
    let componentsName;

    if (typeof node.dataset.component !== 'undefined') {
      componentsName = node.dataset.component.split(',');
    } else {
      componentsName = node.dataset.vanillaComponent.split(',');
    }

    componentsName.forEach((componentName) => {
      if (typeof this.registeredComponents[componentName] === 'undefined') {
        throw new Error(`Failed trying to load component: ${componentName}, define it in the componentLoader.js file`);
      }

      // Get the component
      const Component = { ...this.registeredComponents[componentName] };

      // Props to apply to the component
      const props = node.dataset;

      // If it has a componentName, it's a Vue component
      if (typeof Component.render !== 'undefined') {
        new Vue({ // eslint-disable-line no-new
          el: node,
          data: { props: { ...props } },
          components: { 'base-component': Component },
          template: '<base-component :props="props" />',
        });
        return;
      }

      Component.create(node, props);
    });
  },
};
